const groupAccessPermissions = accessPermissions =>
  accessPermissions.reduce((accumulator, currentValue) => {
    const groupIndex = accumulator.findIndex(item => item.Group === currentValue.Group);
    if (groupIndex === -1) {
      return [
        ...accumulator,
        {
          Group: currentValue.Group,
          items: [currentValue],
        },
      ];
    }
    return [
      ...accumulator.slice(0, groupIndex),
      {
        ...accumulator[groupIndex],
        items: [
          ...accumulator[groupIndex].items,
          currentValue,
        ],
      },
      ...accumulator.slice(groupIndex + 1),
    ];
  }, [
    {
      Group: 'Work Flow',
      items: [],
    },
    {
      Group: 'Schedule',
      items: [],
    },
    {
      Group: 'Charts',
      items: [],
    },
    {
      Group: 'Billing',
      items: [],
    },
    {
      Group: 'Inventory',
      items: [],
    },
    {
      Group: 'Reports',
      items: [],
    },
    {
      Group: 'Business',
      items: [],
    },
    {
      Group: 'Team Management',
      items: [],
    },
    {
      Group: 'System',
      items: [],
    },
    {
      Group: 'Data Portability',
      items: [],
    },
    {
      Group: 'Template',
      items: [],
    },
    {
      Group: 'Payment',
      items: [],
    },
  ]).filter(item => item.items.length > 0);

export default groupAccessPermissions;



// WEBPACK FOOTER //
// ./src/utils/groupAccessPermissions.js